<template>
  <div class="page">
    <div class="box f v fvc">
      <img src="https://j.weizan.cn/youxiang/check-success.png" class="status-img" />

      <div class="tip">签到中</div>
    </div>

    <div class="f v fvc">
      <div class="back-btn" @click="backHome">返回首页</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      kpiUserId: 0,
      userId: 0,
    };
  },
  created() {
    // http://wx.youxiangzb.com/#/signPage?actId=1&kpiUserId=1&addition={\"id\":7}
    if (this.$route.query) {
      this.kpiUserId = this.$route.query.kpi_user_id;
      this.userId = localStorage.getItem("user_id") || "";
      console.log(this.$route.query);
    } else {
      this.$toast("该二维码无效，请核对");
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    }

    // 发生逛店动作
    this.signIn();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 发生逛店动作
    async signIn() {
      let res = await this.$http.post(`/v1/sign/act`, {
        userId: Number(this.userId),
        kpiUserId: Number(this.kpiUserId),
      });
      console.log(res);
      if (res.data && res.data != -1 && res.code == 0) {
        this.$dialog
          .alert({
            message: "签到成功",
            confirmButtonText: "好的",
          })
          .then(() => {
            let tmp = localStorage.getItem("preheatPath") || "prehddd";
            this.$router.push({
              path: tmp,
              query: {
                act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
              },
            });
          });
      } else if (res.data && res.data == -1 && res.code == 0) {
        this.$dialog
          .alert({
            message: "已签到，请勿重复扫码。",
            confirmButtonText: "好的",
          })
          .then(() => {
            let tmp = localStorage.getItem("preheatPath") || "prehddd";
            this.$router.push({
              path: tmp,
              query: {
                act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
              },
            });
          });
      } else {
        this.$dialog
          .alert({
            message: "签到失败，请重新扫码。",
            confirmButtonText: "好的",
          })
          .then(() => {
            let tmp = localStorage.getItem("preheatPath") || "prehddd";
            this.$router.push({
              path: tmp,
              query: {
                act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
              },
            });
          });
      }
    },
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background: #f5f6f7;
  .box {
    padding-bottom: 80px;
    .tip {
      font-size: 14px;
    }
  }
  .back-btn {
    width: 133px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 25px;
  }
  .status-img {
    width: 88px;
    height: 88px;
    margin: 80px 0 20px;
  }
}
</style>